const translation = {
  'howToMakeGoodApp.seo.title': 'How to make a good TEFL course application',
  'howToMakeGoodApp.seo.description':
    'Want to give yourself the best chances of being accepted onto the Trinity CertTESOL course in Barcelona? Find out more.',
  'howToMakeGoodApp.sec1.title': 'How To Make A Good Application',
  'howToMakeGoodApp.sec2.title':
    'The Application Process For The Trinity CertTESOL Course At TEFL Iberia Is As Follows:',
  'howToMakeGoodApp.sec2.ben1': 'You fill in the application form online.',
  'howToMakeGoodApp.sec2.ben2':
    'We send you a short language awareness task to be completed online.',
  'howToMakeGoodApp.sec2.ben3':
    'You complete an interview with the course coordinator (via phone / Skype / FaceTime / Whatsapp / in person at the school).',
};

export default translation;
